import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from "react";
import { ModeToggleSegmentedControl } from "~/components/AssetModalV2/Content/Footer/components/ModeToggleSegmentedControl";
import { FullscreenHeader } from "./FullscreenHeader";
export const FullscreenOverlay = /*#__PURE__*/ memo((param)=>{
    let { navigationArrows, showModeToggle = true } = param;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "fixed left-0 top-2 z-[9999] flex w-full justify-center px-4",
                children: /*#__PURE__*/ _jsx(FullscreenHeader, {
                    navigationArrows: navigationArrows
                })
            }),
            showModeToggle && /*#__PURE__*/ _jsx("div", {
                className: "fixed bottom-8 left-0 z-[9999] flex w-full justify-center",
                children: /*#__PURE__*/ _jsx(ModeToggleSegmentedControl, {})
            })
        ]
    });
});
FullscreenOverlay.displayName = "FullscreenOverlay";
